var ContinuousSignal;

ContinuousSignal = require('../continuous-signal');

module.exports = function(val) {
  return new ContinuousSignal(function(send) {
    send(val);
  });
};
